import React from 'react';

import FormGroupHeader from 'Components/FormGroupHeader';
import InputGroup from 'Components/InputGroup';

const FormFieldGroup = props => {
  const {
    form,
    formStyle,
    type,
    id,
    hideOptionalFlags,
    updateFieldFocus,
    disableFields,
    groupVisibility,
    messageFormat,
    handleInputChange,
    isFormReadOnly,
    group,
  } = props;
  const visbility =
    groupVisibility && groupVisibility[group.id]
      ? groupVisibility[group.id]
      : undefined;
  const hideGroup = group.id && visbility && !visbility.visible;
  return (
    <div
      className="Form__field-group"
      data-hidden={group.hiddenOnMount && hideGroup}
    >
      {visbility && visbility.visibilityComponent
        ? visbility.visibilityComponent
        : null}
      {group.title ? <FormGroupHeader text={group.title} /> : null}
      <div className="Form__fields">
        {group.fields.map(field => {
          const inlineMessage =
            form.message && messageFormat === 'inline'
              ? form.message
              : undefined;
          return (
            <InputGroup
              {...field}
              formStyle={formStyle}
              key={`field-${field.key}`}
              handleChange={handleInputChange}
              handleFocus={e =>
                updateFieldFocus(type, id, e.target.name, e.type)
              }
              focusedField={form.focusedField}
              name={field.key}
              readOnly={isFormReadOnly}
              hideOptionalFlags={hideOptionalFlags}
              inlineMessage={inlineMessage}
              disabled={disableFields}
            />
          );
        })}
      </div>
    </div>
  );
};

export default FormFieldGroup;
